import {
  TtaDisputeReportFormDefaultValues,
  TtaDisputeReportFormProps,
  TtaDisputeReportFormRawValues,
  TtaDisputeReportFormType
} from "./TtaDisputeReportForm";
import {useForm} from "@mantine/form";
import {getObjectId} from "@ots-frontend/ots-data";

const getInitialValues = (defaultValues: TtaDisputeReportFormDefaultValues | undefined): TtaDisputeReportFormRawValues => {
  return {
    fromDate: defaultValues?.fromDate,
    toDate: defaultValues?.toDate,
    operator: getObjectId(defaultValues?.operator),
    rateModel: getObjectId(defaultValues?.rateModel),
    truckCompanies: defaultValues?.truckCompanies?.map(getObjectId).filter((value): value is string => value !== undefined)
  }
}

export type UseTtaDisputeReportFormProps = Pick<TtaDisputeReportFormProps, 'defaultValues'> & {}

export function useTtaDisputeReportForm(props: UseTtaDisputeReportFormProps): TtaDisputeReportFormType {
  const {
    defaultValues
  } = props

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
  })

  return form
}
